// extracted by mini-css-extract-plugin
export default {"workExperienceContainer":"WorkExperience_workExperienceContainer__BEQyW","title":"WorkExperience_title__+MP9R","subTitle":"WorkExperience_subTitle__h4KFr"};